<template>
    <div id="contactus">
        <Banner title="聯絡我們" :breadcrumbs="breadcrumbs"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Contact Us" chtFirst="聯絡" chtSecond="我們" :center="true"></Title>
            </div>
            <section class="content">
                <!-- <div class="global_title">填寫個人資訊</div> -->
                <!-- <div class="box">
                    <form
                        class="form_contact"
                        action="/Home/ContactUs"
                        method="post"
                        ref="form"
                        enctype="multipart/form-data"
                    >
                        <div class="input_span">
                            <span>姓名*</span>
                            <input
                                type="text"
                                placeholder="輸入姓名"
                                v-model="SendData.Name"
                                name="Name"
                            />
                        </div>
                        <div class="input_span">
                            <span>公司名稱</span>
                            <input
                                type="text"
                                placeholder="輸入公司名稱"
                                v-model="SendData.Company"
                                name="Company"
                            />
                        </div>
                        <div class="input_span">
                            <span>聯絡電話*</span>
                            <input
                                type="text"
                                placeholder="輸入聯絡電話"
                                v-model="SendData.Telephone"
                                name="Telephone"
                            />
                        </div>
                        <div class="input_span">
                            <span>E-mail*</span>
                            <input
                                type="text"
                                placeholder="輸入E-mail"
                                v-model="SendData.Email"
                                name="Email"
                            />
                        </div>
                        <div class="input_span">
                            <span>地址*</span>
                            <input
                                type="text"
                                placeholder="輸入地址"
                                v-model="SendData.Adress"
                                name="Adress"
                            />
                        </div>
                        <div class="input_span">
                            <span>請選擇問題類型*</span>
                            <select v-model="SendData.QuestionType" name="QuestionType">
                                <option value="null" disabled>問題類型</option>
                                <option value="醫病諮詢">醫病諮詢</option>
                                <option value="廠商合作">廠商合作</option>
                            </select>
                        </div>
                        <div class="input_span">
                            <span>標題*</span>
                            <input
                                type="text"
                                placeholder="輸入訊息標題"
                                v-model="SendData.Title"
                                name="Title"
                            />
                        </div>
                        <div class="input_span">
                            <span>訊息內容*</span>
                            <textarea
                                placeholder="輸入訊息內容"
                                v-model="SendData.Content"
                                name="Content"
                            ></textarea>
                        </div>
                    </form>
                    <div class="input_span">
                        <span>請輸入驗證碼</span>
                        <div class="id">
                            <input type="text" placeholder="請輸入下方驗證碼" v-model="InputId" />
                            <Sidentify :identifyCode="identifyCode"></Sidentify>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="24"
                                height="24"
                                viewBox="0 0 172 172"
                                style=" fill:#000000;"
                                @click="refreshCode"
                            >
                                <g
                                    fill="none"
                                    fill-rule="none"
                                    stroke="none"
                                    stroke-width="1"
                                    stroke-linecap="butt"
                                    stroke-linejoin="miter"
                                    stroke-miterlimit="10"
                                    stroke-dasharray
                                    stroke-dashoffset="0"
                                    font-family="none"
                                    font-weight="none"
                                    font-size="none"
                                    text-anchor="none"
                                    style="mix-blend-mode: normal"
                                >
                                    <path d="M0,172v-172h172v172z" fill="none" fill-rule="nonzero" />
                                    <g fill="#333333" fill-rule="evenodd">
                                        <g id="surface1">
                                            <path
                                                d="M109.82357,31.85808c-13.10156,-5.76693 -27.88281,-6.66276 -41.62826,-2.32357c-26.11914,8.23047 -43.05599,33.00586 -41.29232,60.27278l-17.83268,1.17578c-2.29557,-35.5254 19.79232,-67.7754 53.75,-78.4974c19.87631,-6.27083 41.43229,-4.08724 59.71289,5.79492l17.10482,-18.2806l4.56315,50.69857l-53.69401,1.79167zM109.15169,159.51433c-7.5306,2.35156 -15.34115,3.55533 -23.0957,3.55533c-12.65365,0 -25.22331,-3.27539 -36.5612,-9.37825l-17.13281,18.30859l-4.53515,-50.69857l53.66601,-1.79167l-19.28841,20.63217c13.04557,5.73893 27.82682,6.66276 41.57226,2.32356c26.11914,-8.25846 43.08399,-33.06185 41.32031,-60.27278l17.80469,-1.17578c2.35156,35.4694 -19.76433,67.7474 -53.75,78.4974z"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="btn_box">
                        <div class="item">
                            <div class="White_btn islogin" @click="Reset">
                                <a href="javascript:;">重新填寫</a>
                            </div>
                        </div>
                        <div class="item">
                            <div class="Orange_btn islogin">
                                <a href="javascript:;" @click="Send">確認送出</a>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="global_title">聯絡資訊</div>
                <ul class="message">
                    <li>中華民國視網膜醫學會</li>
                    <li>電話:0965-106-869</li>
                    <li>Email:twrs.tw@gmail.com</li>
                    <li>地址:台北市中正區常德街一號景福館2樓206室</li>
                </ul>
                <div class="google_map">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.804693293772!2d121.51407001500642!3d25.04070128396921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a974322dffc1%3A0x20546e125e9f67a!2zMTAw5Y-w5YyX5biC5Lit5q2j5Y2A5YWs5ZyS6LevMTUtMuiZn-WupO-8iOaZr-emj-mkqA!5e0!3m2!1szh-TW!2stw!4v1564992619034!5m2!1szh-TW!2stw"
                        width="100%"
                        height="450"
                        frameborder="0"
                        style="border:0"
                        allowfullscreen
                    ></iframe>
                </div>
            </section>
            <graybtn />
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import Sidentify from "@/components/identify";
export default {
    name: "contactus",
    components: {
        Sidentify
    },
    props: {
        issuccess: {
            type: Boolean
        }
    },
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    url: "/contactus",
                    title: "聯絡我們"
                }
            ],
            //圖形驗證
            identifyCode: "",
            // identifyCodes: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            identifyCodes: "23456789ABCDEFGHJKMNPQRSTUVWXYZ",
            SendData: {
                Name: "",
                Company: "",
                Telephone: "",
                Email: "",
                // Adress: "",
                // QuestionType: "null",
                Title: "",
                Content: ""
            },
            InputId: "",
            isLoading: false
        };
    },
    methods: {
        /*圖形驗證*/
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
            // console.log("當前驗證碼==", this.identifyCode);
        },
        makeCode(o, length) {
            for (let i = 0; i < length; i++) {
                this.identifyCode += o[this.randomNum(0, o.length)];
            }
        },
        Send() {
            const vm = this;
            for (let [key, value] of Object.entries(vm.SendData)) {
                if (key != "Company") {
                    if (value == "" || value == "null") {
                        vm.$swal({
                            type: "warning",
                            text: "尚有欄位未填寫!",
                            confirmButtonText: "確定"
                        });
                        return false;
                    }
                }
            }
            if (vm.InputId != vm.identifyCode) {
                vm.$swal({
                    type: "warning",
                    text: "驗證碼輸入錯誤!",
                    confirmButtonText: "確定"
                });
                vm.refreshCode();
                return false;
            }
            vm.isLoading = true;
            vm.$refs.form.submit();
        },
        Reset() {
            const vm = this;
            vm.SendData = {
                Name: "",
                Company: "",
                Telephone: "",
                Email: "",
                // Adress: "",
                // QuestionType: "null",
                Title: "",
                Message: ""
            };
        }
    },
    computed: {},
    created() {
        const vm = this;
        vm.refreshCode(); //初始化圖形驗證
    },
    mounted() {
        const vm = this;
        if (vm.issuccess) {
            vm.$swal({
                type: "success",
                text: "寄信成功，請等待3 ~ 5個工作天後將寄送信件通知!",
                confirmButtonText: "確定"
            });
        }
    },
    watch: {}
};
</script>

<style  scoped>
#contactus .content {
    border: 8px solid #eee;
    padding: 20px;
    color: #666;
}
#contactus .content .box {
    display: flex;
    flex-direction: column;
    align-items: center;
}
#contactus .content .message {
    padding: 0 16px;
    margin-bottom: 30px;
}
#contactus .form_contact {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
#contactus .none {
    display: none;
}
@keyframes oxxo {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
#contactus .content .box .btn_box {
    margin: auto;
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    /* width: 350px; */
    padding: 30px 0;
}
#contactus .content .box .btn_box .item {
    width: 48%;
}
#contactus .content .message li {
    letter-spacing: 2px;
    line-height: 1.5;
    padding: 5px 0;
}
@media screen and (max-width: 767px) {
    #contactus .content {
        padding: 20px 10px;
    }
    #contactus .content .box .id {
        width: 100%;
    }
    #contactus .content .message {
        padding: 0;
    }
    #contactus .content .box .btn_box {
        width: 100%;
    }
    #contactus .content .box .btn_box .item {
        margin-bottom: 15px;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/contactus.vue